import React, { Component } from "react";
import { Formik } from "formik";
import "react-toggle/style.css";
import { connect } from "react-redux";
import {
  Card,
  Button,
  Collapse,
  Form,
  FormGroup,
  InputGroup,
  Input,
  FormFeedback,
  Label,
} from "reactstrap";
import { FormHeader, UpDownCaretArrow } from "components";
import {
  appendOperatorPurchaseDetails,
} from "../actions";
import { handleError, openNotificationWithIcon } from "../../../appRedux/actions/Common";
import { config } from "constants/config";
import api from "appRedux/api";
import SeatSelector from "./SeatSelector";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';

class ExpandableReserveForm extends Component {
  state = {
    isCollapse: false,
    selectedRoutes: "",
    price: 0,
    tripDetails: null,
    reserving: false,
    loading: false,
    defaultCountry: 'ng',
    useSameNextOfKin: false,
  };

  toggleContactForm = () => {
    this.setState((prevState) => ({ isCollapse: !prevState.isCollapse }));
  };

  componentDidMount() {
    const { countryProperties } = this.props;
    let defaultCountry = 'ng';
    
    if (countryProperties && countryProperties.country_code) {
      defaultCountry = countryProperties.country_code.toLowerCase();
    }
    
    this.setState({
      price: this.props.operator.price,
      selectedRoutes: this.props.operator.name,
      defaultCountry: defaultCountry,
    });
    this.getTripDetails();
  }

  getTripDetails = async () => {
    this.setState({ loading: true });
    try {
      const { operator } = this.props;
      if (!operator?.tripId) {
        handleError("No tripId provided in props.operator");
        return;
      }

      const url = `/trip/whitelabel/seat/${operator.tripId}`;
      const response = await api.get(
        url,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
        config.baseUrl
      );
      this.setState({ isCollapse: true, loading: false, tripDetails: response?.data || response });
    } catch (err) {
      console.error("Error fetching trip details:", err);
      handleError("unable to fetch available seat at the moment please try later", err);
      this.setState({ isCollapse: false, loading: false });
    }
  };

  formatPhoneWithPlus = (phone) => {
    if (!phone) return '';
    return phone.startsWith('+') ? phone : `+${phone}`;
  };

  validateInternationalPhone = (phone) => {
    if (!phone) return false;
    const phoneRegex = /^\+\d{5,15}$/;
    return phoneRegex.test(phone);
  };

  handleUseSameNextOfKinChange = (e, setFieldValue, values) => {
    const isChecked = e.target.checked;
    this.setState({ useSameNextOfKin: isChecked });
    
    if (isChecked) {
      const numUnits = parseInt(values.units) || 0;
      const extraPassengerCount = numUnits > 1 ? numUnits - 1 : 0;
      
      for (let i = 0; i < extraPassengerCount; i++) {
        setFieldValue(`extraPassengerNextOfKinName${i}`, values.nextOfKinName);
        setFieldValue(`extraPassengerNextOfKin${i}`, values.nextOfKin);
      }
    }
  };

  render() {
    const { isCollapse, price, tripDetails, defaultCountry, useSameNextOfKin, reserving, loading } = this.state;
    const { handleCompletion, color, countryProperties } = this.props;

    return (
      <Card className="login-form__card">
        <FormHeader
          title={this.props.operator.operator}
          style={{ marginBottom: "0" }}
        >
          <UpDownCaretArrow isCollapse={isCollapse} />
        </FormHeader>
        <p>{this.props.operator.route}</p>
        <p style={{ color: "green" }}>{loading ? "fetching available seat..." : null}</p>
        <Collapse isOpen={isCollapse}>
          <Formik
            enableReinitialize
            initialValues={{
              units: "",
              selectedSeats: [],
              email: "",
              phone: "",
              nextOfKin: "",
              nextOfKinName: "",
              name: "",
              gender: "",
            }}
            onSubmit={(values, { setSubmitting }) => {
              const passengerList = [];
              const selectedSeats = values.selectedSeats || [];
              const numUnits = parseInt(values.units) || 1;
            
              const seatNumbersOnly = selectedSeats.map(seat => seat.seatNumber);
            
              passengerList.push({
                passengerName: values.name,
                passengerPhoneNumber: this.formatPhoneWithPlus(values.phone),
                passengerGender: values.gender,
                passengerNextOfKinName: values.nextOfKinName,
                passengerNextOfKinPhoneNumber: this.formatPhoneWithPlus(values.nextOfKin),
                seatNumber: seatNumbersOnly[0] || "",
              });
            
              for (let i = 0; i < numUnits - 1; i++) {
                passengerList.push({
                  passengerName: values[`extraPassengerName${i}`],
                  passengerPhoneNumber: this.formatPhoneWithPlus(values[`extraPassengerPhone${i}`]),
                  passengerGender: values[`extraPassengerGender${i}`],
                  passengerNextOfKinName: values[`extraPassengerNextOfKinName${i}`],
                  passengerNextOfKinPhoneNumber: this.formatPhoneWithPlus(values[`extraPassengerNextOfKin${i}`]),
                  seatNumber: seatNumbersOnly[i + 1] || "",
                });
              }
            
              const submitOperatorData = {
                operatorId: this.props.operator.operatorId,
                units: values.units,
                tripId: this.props.operator.tripId,
                name: values.name,
                email: values.email,
                phone: this.formatPhoneWithPlus(values.phone),
                nextOfKin: this.formatPhoneWithPlus(values.nextOfKin),
                selectedRoutes: this.props.operator.route,
                travelRouteId: this.props.operator.routeId,
                amount: price,
                passengers: passengerList,
                seats: seatNumbersOnly,
              };
            
              this.props.sendSingleOperator(submitOperatorData);
            
              this.setState({ reserving: true });
            
              api.post(
                `/trip/whitelabel/reservation`,
                {
                  tripId: this.props.operator.tripId,
                  seatNumber: seatNumbersOnly,
                },
                config.baseUrl
              )
                .then(() => {
                  this.setState({ reserving: false });
                  openNotificationWithIcon(
                    "Seat Reserved successfully, please proceed to payment"
                  );
                  setSubmitting(true);
                  if (handleCompletion) handleCompletion();
                })
                .catch((error) => {
                  this.setState({ reserving: false });
                  console.error("Error Reserving Seat:", error);
                  handleError(error?.message || "Network Error");
                })
                .finally(() => {
                  this.setState({ reserving: false });
                  this.getTripDetails();
                  setSubmitting(false);
                });
            }}
            validate={(values) => {
              const errors = {};
              const numUnits = parseInt(values.units) || 0;
              const extraPassengerCount = numUnits > 1 ? numUnits - 1 : 0;

              const formattedPhone = this.formatPhoneWithPlus(values.phone);
              const formattedNextOfKin = this.formatPhoneWithPlus(values.nextOfKin);

              if (!values.units) errors.units = "Please enter a Unit";
              
              if (!values.email) {
                errors.email = "Email is required";
              } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(values.email)) {
                errors.email = "Invalid email address";
              }
              
              if (!values.phone) {
                errors.phone = "Phone number is required";
              } else if (!this.validateInternationalPhone(formattedPhone)) {
                errors.phone = "Phone number must be in international format (e.g., +2348012345678) and contain 5-15 digits";
              }
              
              if (!values.name) errors.name = "Name is required";
              if (!values.gender) errors.gender = "Gender is required";
              if (!values.nextOfKinName) errors.nextOfKinName = "Next of kin name is required";
              
              if (!values.nextOfKin) {
                errors.nextOfKin = "Next of kin number is required";
              } else if (!this.validateInternationalPhone(formattedNextOfKin)) {
                errors.nextOfKin = "Next of kin number must be in international format (e.g., +2348012345678) and contain 5-15 digits";
              }
              
              if (formattedPhone && formattedNextOfKin && formattedPhone === formattedNextOfKin) {
                errors.nextOfKin = "Next of kin number must not be the same as customer number";
              }

              if (!values.selectedSeats || values.selectedSeats.length !== numUnits) {
                errors.selectedSeats = `You must select exactly ${values.units || 0} seat(s)`;
              }

              for (let i = 0; i < extraPassengerCount; i++) {
                const formattedPassengerPhone = this.formatPhoneWithPlus(values[`extraPassengerPhone${i}`]);
                const formattedPassengerNextOfKin = this.formatPhoneWithPlus(values[`extraPassengerNextOfKin${i}`]);

                if (!values[`extraPassengerName${i}`]) {
                  errors[`extraPassengerName${i}`] = "Passenger name is required";
                }
                if (!values[`extraPassengerGender${i}`]) {
                  errors[`extraPassengerGender${i}`] = "Passenger gender is required";
                }
                
                if (!values[`extraPassengerPhone${i}`]) {
                  errors[`extraPassengerPhone${i}`] = "Passenger phone is required";
                } else if (!this.validateInternationalPhone(formattedPassengerPhone)) {
                  errors[`extraPassengerPhone${i}`] = "Phone number must be in international format (e.g., +2348012345678)";
                }
                
                if (!values[`extraPassengerNextOfKinName${i}`]) {
                  errors[`extraPassengerNextOfKinName${i}`] = "Next of kin name is required";
                }
                
                if (!values[`extraPassengerNextOfKin${i}`]) {
                  errors[`extraPassengerNextOfKin${i}`] = "Next of kin number is required";
                } else if (!this.validateInternationalPhone(formattedPassengerNextOfKin)) {
                  errors[`extraPassengerNextOfKin${i}`] = "Next of kin number must be in international format (e.g., +2348012345678)";
                }
                
                if (formattedPassengerPhone && formattedPassengerNextOfKin && 
                    formattedPassengerPhone === formattedPassengerNextOfKin) {
                  errors[`extraPassengerNextOfKin${i}`] = "Next of kin number must not be the same as passenger number";
                }
              }

              return errors;
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              values,
              errors,
              touched,
              isValidating,
              setFieldValue,
              isSubmitting,
            }) => {
              const numUnits = parseInt(values.units) || 0;
              const extraPassengerCount = numUnits > 1 ? numUnits - 1 : 0;

              const handleDuplicateNextOfKin = () => {
                for (let i = 0; i < extraPassengerCount; i++) {
                  setFieldValue(
                    `extraPassengerNextOfKinName${i}`,
                    values.nextOfKinName
                  );
                  setFieldValue(
                    `extraPassengerNextOfKin${i}`,
                    values.nextOfKin
                  );
                }
              };

              const handlePhoneChange = (value, fieldName) => {
                setFieldValue(fieldName, value);
              };

              // Check if all main fields are filled (matching the working pattern)
              const allMainFieldsFilled = 
                values.units && 
                values.name && 
                values.gender && 
                values.phone && 
                !errors.phone && 
                values.email && 
                !errors.email && 
                values.nextOfKin && 
                !errors.nextOfKin && 
                values.nextOfKinName &&
                values.selectedSeats &&
                values.selectedSeats.length === numUnits;

              
              let allExtraFieldsFilled = true;
              for (let i = 0; i < extraPassengerCount; i++) {
                if (
                  !values[`extraPassengerName${i}`] ||
                  !values[`extraPassengerGender${i}`] ||
                  !values[`extraPassengerPhone${i}`] ||
                  errors[`extraPassengerPhone${i}`] ||
                  !values[`extraPassengerNextOfKinName${i}`] ||
                  !values[`extraPassengerNextOfKin${i}`] ||
                  errors[`extraPassengerNextOfKin${i}`]
                ) {
                  allExtraFieldsFilled = false;
                  break;
                }
              }

              const isFormValid = allMainFieldsFilled && (extraPassengerCount === 0 || allExtraFieldsFilled);

              const extraPassengerFields = [];
              for (let i = 0; i < extraPassengerCount; i++) {
                extraPassengerFields.push(
                  <div key={i} className="border p-2 mb-3">
                    <p><strong>Passenger {i + 2} Info</strong></p>
                    
                    <InputGroup className="mb-2">
                      <Input
                        type="text"
                        name={`extraPassengerName${i}`}
                        placeholder="Full Name"
                        value={values[`extraPassengerName${i}`] || ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        invalid={
                          !!(
                            errors[`extraPassengerName${i}`] &&
                            touched[`extraPassengerName${i}`]
                          )
                        }
                        required
                      />
                      {errors[`extraPassengerName${i}`] &&
                        touched[`extraPassengerName${i}`] && (
                          <FormFeedback>
                            {errors[`extraPassengerName${i}`]}
                          </FormFeedback>
                        )}
                    </InputGroup>
                    
                    <InputGroup className="mb-2">
                      <Input
                        type="select"
                        name={`extraPassengerGender${i}`}
                        value={values[`extraPassengerGender${i}`] || ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        invalid={
                          !!(
                            errors[`extraPassengerGender${i}`] &&
                            touched[`extraPassengerGender${i}`]
                          )
                        }
                        required
                      >
                        <option value="">Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                      </Input>
                      {errors[`extraPassengerGender${i}`] &&
                        touched[`extraPassengerGender${i}`] && (
                          <FormFeedback>
                            {errors[`extraPassengerGender${i}`]}
                          </FormFeedback>
                        )}
                    </InputGroup>
                    
                    <div className="mb-2">
                      <PhoneInput
                        country={defaultCountry}
                        value={values[`extraPassengerPhone${i}`] || ""}
                        onChange={(value) => handlePhoneChange(value, `extraPassengerPhone${i}`)}
                        onBlur={handleBlur}
                        inputProps={{
                          name: `extraPassengerPhone${i}`,
                          required: true,
                        }}
                        containerClass="phone-input-container"
                        inputClass="phone-input-field"
                        buttonClass="phone-input-button"
                        dropdownClass="phone-input-dropdown"
                        enableSearch={true}
                        disableSearchIcon={true}
                        placeholder="Phone number"
                      />
                      {errors[`extraPassengerPhone${i}`] &&
                        touched[`extraPassengerPhone${i}`] && (
                          <div className="text-danger small mt-1">
                            {errors[`extraPassengerPhone${i}`]}
                          </div>
                        )}
                    </div>
                    
                    <InputGroup className="mb-2">
                      <Input
                        type="text"
                        name={`extraPassengerNextOfKinName${i}`}
                        placeholder="Next of kin name"
                        value={values[`extraPassengerNextOfKinName${i}`] || ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        invalid={
                          !!(
                            errors[`extraPassengerNextOfKinName${i}`] &&
                            touched[`extraPassengerNextOfKinName${i}`]
                          )
                        }
                        required
                      />
                      {errors[`extraPassengerNextOfKinName${i}`] &&
                        touched[`extraPassengerNextOfKinName${i}`] && (
                          <FormFeedback>
                            {errors[`extraPassengerNextOfKinName${i}`]}
                          </FormFeedback>
                        )}
                    </InputGroup>
                    
                    <div className="mb-2">
                      <PhoneInput
                        country={defaultCountry}
                        value={values[`extraPassengerNextOfKin${i}`] || ""}
                        onChange={(value) => handlePhoneChange(value, `extraPassengerNextOfKin${i}`)}
                        onBlur={handleBlur}
                        inputProps={{
                          name: `extraPassengerNextOfKin${i}`,
                          required: true,
                        }}
                        containerClass="phone-input-container"
                        inputClass="phone-input-field"
                        buttonClass="phone-input-button"
                        dropdownClass="phone-input-dropdown"
                        enableSearch={true}
                        disableSearchIcon={true}
                        placeholder="Next of kin number"
                      />
                      {errors[`extraPassengerNextOfKin${i}`] &&
                        touched[`extraPassengerNextOfKin${i}`] && (
                          <div className="text-danger small mt-1">
                            {errors[`extraPassengerNextOfKin${i}`]}
                          </div>
                        )}
                    </div>
                  </div>
                );
              }

              return (
                <Form onSubmit={handleSubmit}>
                  <h4>
                    {price
                      ? new Intl.NumberFormat(countryProperties?.locale || 'en-NG', {
                          style: "currency",
                          currency: countryProperties?.currency_code || 'NGN',
                        }).format(price)
                      : null}
                  </h4>

                  <FormGroup>
                    <InputGroup className="mb-3">
                      <Input
                        type="number"
                        name="units"
                        placeholder="Number of ticket"
                        value={values.units}
                        min="1"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        invalid={!!(errors.units && touched.units)}
                        required
                        onKeyDown={(e) =>
                          ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
                        }
                      />
                      {errors.units && touched.units && (
                        <FormFeedback>{errors.units}</FormFeedback>
                      )}
                    </InputGroup>

                    {tripDetails?.data?.seats && values.units && (
                      <div className="mb-3">
                        <SeatSelector
                          seats={tripDetails.data.seats}
                          maxSeats={parseInt(values.units) || 1}
                          onSelect={(selectedSeats) => {
                            setFieldValue("selectedSeats", selectedSeats);
                          }}
                        />
                        {errors.selectedSeats && (
                          <center><div className="text-danger">{errors.selectedSeats}</div></center>
                        )}
                      </div>
                    )}

                    <InputGroup className="mb-3">
                      <Input
                        type="text"
                        name="name"
                        placeholder="Name"
                        value={values.name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        invalid={!!(errors.name && touched.name)}
                        required
                      />
                      {errors.name && touched.name && (
                        <FormFeedback>{errors.name}</FormFeedback>
                      )}
                    </InputGroup>
                    
                    <InputGroup className="mb-3">
                      <Input
                        type="select"
                        name="gender"
                        value={values.gender}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        invalid={!!(errors.gender && touched.gender)}
                        required
                      >
                        <option value="">Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Other">Other</option>
                      </Input>
                      {errors.gender && touched.gender && (
                        <FormFeedback>{errors.gender}</FormFeedback>
                      )}
                    </InputGroup>
                    
                    <div className="mb-3">
                      <PhoneInput
                        country={defaultCountry}
                        value={values.phone || ""}
                        onChange={(value) => handlePhoneChange(value, 'phone')}
                        onBlur={handleBlur}
                        inputProps={{
                          name: 'phone',
                          required: true,
                        }}
                        containerClass="phone-input-container"
                        inputClass="phone-input-field"
                        buttonClass="phone-input-button"
                        dropdownClass="phone-input-dropdown"
                        enableSearch={true}
                        disableSearchIcon={true}
                        placeholder="Phone number"
                      />
                      {errors.phone && touched.phone && (
                        <div className="text-danger small mt-1">{errors.phone}</div>
                      )}
                    </div>
                    
                    <InputGroup className="mb-3">
                      <Input
                        type="email"
                        name="email"
                        placeholder="Email"
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        invalid={!!(errors.email && touched.email)}
                        required
                      />
                      {errors.email && touched.email && (
                        <FormFeedback>{errors.email}</FormFeedback>
                      )}
                    </InputGroup>
                    
                    <InputGroup className="mb-3">
                      <Input
                        type="text"
                        name="nextOfKinName"
                        placeholder="Next of kin name"
                        value={values.nextOfKinName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        invalid={!!(errors.nextOfKinName && touched.nextOfKinName)}
                        required
                      />
                      {errors.nextOfKinName && touched.nextOfKinName && (
                        <FormFeedback>{errors.nextOfKinName}</FormFeedback>
                      )}
                    </InputGroup>
                    
                    <div className="mb-3">
                      <PhoneInput
                        country={defaultCountry}
                        value={values.nextOfKin || ""}
                        onChange={(value) => handlePhoneChange(value, 'nextOfKin')}
                        onBlur={handleBlur}
                        inputProps={{
                          name: 'nextOfKin',
                          required: true,
                        }}
                        containerClass="phone-input-container"
                        inputClass="phone-input-field"
                        buttonClass="phone-input-button"
                        dropdownClass="phone-input-dropdown"
                        enableSearch={true}
                        disableSearchIcon={true}
                        placeholder="Next of kin phone number"
                      />
                      {errors.nextOfKin && touched.nextOfKin && (
                        <div className="text-danger small mt-1">{errors.nextOfKin}</div>
                      )}
                    </div>

                    {extraPassengerCount > 0 && allMainFieldsFilled && (
                      <div className="mb-3 p-2 border rounded" style={{ backgroundColor: '#f8f9fa' }}>
                        <FormGroup check className="d-flex align-items-center">
                          <Label check className="d-flex align-items-center" style={{ cursor: 'pointer' }}>
                            <Input 
                              type="checkbox" 
                              checked={useSameNextOfKin}
                              onChange={(e) => this.handleUseSameNextOfKinChange(e, setFieldValue, values)}
                              style={{ marginRight: '10px', width: '18px', height: '18px', cursor: 'pointer',marginBottom:"5px"   }}
                            />
                            <span style={{ fontSize: '1rem', fontWeight: '500' }}>
                              Use same next of kin for all passengers
                            </span>
                          </Label>
                        </FormGroup>
                        {useSameNextOfKin && values.nextOfKinName && values.nextOfKin && (
                          <div className="mt-2 small text-success">
                            ✓ Next of kin information will be applied to all passengers: 
                            <strong> {values.nextOfKinName}</strong> ({values.nextOfKin})
                          </div>
                        )}
                      </div>
                    )}

                    {extraPassengerFields}
                  </FormGroup>

                  <Button
                    block
                    style={{
                      height: "45px",
                      background: color,
                      marginBottom: "2rem",
                    }}
                    type="submit"
                    disabled={!isFormValid || isValidating || isSubmitting || reserving}
                  >
                    {reserving ? "Reserving Seat..." : "Reserve"}
                  </Button>
                </Form>
              );
            }}
          </Formik>
        </Collapse>
      </Card>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  sendSingleOperator: (data) => dispatch(appendOperatorPurchaseDetails(data)),
  handleError: (err) => dispatch(handleError(err)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExpandableReserveForm);